<div class="preview-progression"
     [ngClass]="getProgressionState()"></div>